import { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Navbar as ProcessNavbar } from './components/Navbar';

import { Process } from './index';

export const PipelineRoutes = (): JSX.Element => (
    <Fragment>
        <ProcessNavbar />
        <Routes>
            <Route path=":processName" element={<Process />} />
            <Route path="*" element={<Navigate to="sales" replace />} />
        </Routes>
    </Fragment>
);
